import { createContext } from 'react'

export const MainContext = createContext<{
  [key: string]: any
}>({})
